module.exports = __webpack_public_path__ + "media/images/icon__point--lost-09d81774baf416b002d3ea9b12a1c898.png";